module.exports = __webpack_public_path__ + "img/4.497d04a5.png";